export interface EffectiveIdentityState {
  auth: {
    user: { id: string } | null;
    impersonation: {
      active: boolean;
      targetId: string;
    } | null;
  };
}

/**
 * Returns the person whose data the active bearer token is expected to access.
 * Impersonation takes precedence over the normal auth user because the Redux
 * session swap and persisted-state hydration can briefly expose both values.
 */
export function selectEffectivePersonId(state: EffectiveIdentityState): string | null {
  const impersonation = state.auth.impersonation;
  if (impersonation?.active && impersonation.targetId) {
    return impersonation.targetId;
  }

  return state.auth.user?.id ?? null;
}
